export enum EKeycloakPortalClientID {
  ADMIN_MGMT_PORTAL = 'administration-management-portal',
  AGENT_PORTAL = 'agents-portal',
  INTEGRATION_MGMT_PORTAL = 'integration-management-portal',
  OFFICER_PORTAL = 'officers-portal',
  ORGANIZATION_MGMT_PORTAL = 'organization-management-portal',
  SERVICE_MGMT_PORTAL = 'service-management-portal',
  PRIVATE_PORTAL = 'private-portal',
  ONE_STOP_CENTER_PORTAL = 'one-stop-center-portal',
}
